import Vue from 'vue'
import { createAndMountInstance } from 'util/loader-helper'
import domUtils from 'util/dom-utils'
import embeddedSubmissionConfig from './embedded-submission.config'
import submissionStore from 'store/submission-store'

const SUBMISSION_MODAL_ID = 'tt-submission-modal'
let modalWasLoaded = false
let root: Vue

export default {
  load() {
    return new Promise((resolve) => {
      if (embeddedSubmissionConfig.divId) {
        // tslint:disable-next-line
        import(/* webpackChunkName: 'embedded-submission' */ './embedded-submission').then((EmbeddedSubmission) => {
          createAndMount(EmbeddedSubmission.default, embeddedSubmissionConfig.divId, root)
            .then(() => resolve())
        })
      } else if (modalWasLoaded) {
        submissionStore.isOpen = true
        resolve()
      } else if (!document.getElementById(SUBMISSION_MODAL_ID)) {
        // This creates a div as a descendant of body with an id used for submission-modal.
        // It then mounts the submission-modal component if not already mounted.
        domUtils.appendDivToBody(SUBMISSION_MODAL_ID)
        // tslint:disable-next-line
        import(/* webpackChunkName: 'submission-modal' */ './submission-modal').then((SubmissionModal) => {
          createAndMount(SubmissionModal.default, SUBMISSION_MODAL_ID)
            .then(() => {
              modalWasLoaded = true
              resolve()
            })
        })
      } else {
        resolve()
      }
    })
  }
}

function createAndMount(widget, divId, existingInstance: Vue = null) {
  return createAndMountInstance(
    existingInstance,
    widget,
    divId
  ).then((instance) => {
    root = instance
    submissionStore.isOpen = true
  })
}
